import axios from '../../axiosConfig/metaaxios'
import axios2 from '../../axiosConfig/axios'
export const buyNfts = {
  buyProduct: async (data, token, callback) => {
    for (let key in data) {
      if(typeof data[key] == 'bigint') {
        data[key] = Number(data[key].toString())
      }
    }
    axios
      .post(
        '/buyNFT',
        {
          ...data,
          token: token
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(data => {
        callback(null, data)
      })
      .catch(err => {
        console.log(err)
        callback(err, null)
      })
  },
  getTransactionHistory: async (link, token, callback) => {
    axios
      .get(`/transactionHistory?${link}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then(data => {
        callback(null, data)
      })
      .catch(err => {
        callback(err, null)
      })
  },
  getSellNfts: async (nftsId, token, callback) => {
    axios
      .get(`/getSellNFTs/?category=sell&nftId=${nftsId}&token=${token}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then(data => {
        callback(null, data)
      })
      .catch(err => {
        callback(err, null)
      })
  },
  generateOtp: (code, token, cb) => {
    var data =
      code == null
        ? {}
        : {
            code: code
          }
    axios2
      .post('/generateOTP', data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then(data => {
        console.log(data)
        cb(data, null)
      })
      .catch(err => {
        console.log(err)
        cb(null, err)
      })
  },
  getNftDetails: (url, id, type, cb) => {

    axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json'
          // 'Authorization': `Bearer ${token}`
        }
      })
      .then(data => {
        cb(null, data)
      })
      .catch(err => {
        cb(err, null)
      })
  },
  getCountries: cb => {
    axios
      .get(`/countries`, {
        headers: {
          'Content-Type': 'application/json'
          // 'Authorization': `Bearer ${token}`
        }
      })
      .then(data => {
        cb(null, data)
      })
      .catch(err => {
        cb(err, null)
      })
  },
  getNetworkNft: (networkId, pageNumber, limit, ids, callback) => {
    axios
      .get(
        `/paginatedNfts/${pageNumber}?network=${networkId}&limit=${40}&nfts=${ids}`,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then(data => {
        console.log(data)
        callback(null, data)
      })
      .catch(err => {
        console.log(err)
        callback(err, null)
      })
  },
  getWinz: async (token, callback) => {
    axios
      .get(`/getWinz`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      .then(data => {
        callback(null, data)
      })
      .catch(err => {
        callback(err, null)
      })
  }
}
